<div class="title">روز شروع برنامه غذایی خود را انتخاب کنید</div>
<div class="container">
  <div class="holder" id="holder">
    <div *ngFor="let startday of startDays; let i = index" class="day">
      {{ startday }}
    </div>
  </div>
  <div class="line-top">
    <div class="white-top"></div>
    <div class="gradient-top"></div>
  </div>
  <div class="line-bot">
    <div class="gradient-bot"></div>
    <div class="white-bot"></div>
  </div>
  <div
    class="gesture"
    (swipeup)="swipe($event.type, $event)"
    (swipedown)="swipe($event.type, $event)"
  ></div>
</div>
